const BASE_URL = 'https://saavn.sumit.co/api';

const apiService = {
  /**
   * Search for songs
   * @param {string} query 
   * @returns {Promise<Array>}
   */
  async searchSongs(query) {
    try {
      const response = await fetch(`${BASE_URL}/search/songs?query=${encodeURIComponent(query)}`);
      const data = await response.json();
      return data?.success ? data.data.results : [];
    } catch (error) {
      console.error('Error searching songs:', error);
      return [];
    }
  },

  /**
   * Get lyrics for a song
   * @param {string} id 
   * @returns {Promise<Object>}
   */
  async getLyrics(id) {
    try {
      const response = await fetch(`${BASE_URL}/songs/${id}/lyrics`);
      const data = await response.json();
      return data?.success ? data.data : null;
    } catch (error) {
      console.error('Error getting lyrics:', error);
      return null;
    }
  },

  /**
   * Get song details by ID or link
   * @param {Object} params { ids, link }
   * @returns {Promise<Array>}
   */
  async getSongDetails({ ids, link }) {
    try {
      let query = '';
      if (ids) query = `ids=${ids}`;
      else if (link) query = `link=${encodeURIComponent(link)}`;
      
      const response = await fetch(`${BASE_URL}/songs?${query}`);
      const data = await response.json();
      return data?.success ? data.data : [];
    } catch (error) {
      console.error('Error getting song details:', error);
      return [];
    }
  }
};

export default apiService;
